<template>
  <div class="stationery">
    <stationeryHeader
      @addStationeryShowChange="addStationeryShowChange"
      @stationerySearch="stationerySearch"
    />
    <!-- 列表栏容器 -->
    <div class="stationery-info-table-container" v-bitmap="getListResult">
      <stationeryList
        class="stationery-list"
        v-show="total"
        :stationeryList="stationeryList"
      />
    </div>
    <!-- 分页容器 -->
    <div class="stationery-info-pagination-catainer">
      <pagination
        :total="parseInt(total)"
        :pageSize="parseInt(pageSize)"
        @currentPageNumChange="currentPageNumChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <addStationery
      v-show="addStationeryShow"
      :addStationeryShow.sync="addStationeryShow"
    />
  </div>
</template>

<script>
import stationeryHeader from "./components/stationery-header/stationeryHeader.vue";
import stationeryList from "./components/stationery-list/stationeryList.vue";
import addStationery from "./components/stationery-add/stationeryAdd.vue";
export default {
  components: {
    stationeryHeader,
    stationeryList,
    addStationery,
  },
  data() {
    return {
      getListResult: "nullData",
      total: 0,
      pageNum: 1, // 当前页码
      pageSize: 10, // 每页条数
      stationeryList: [],
      addStationeryShow: false,
      stationeryName: "",
    };
  },
  created() {
    this.getStationeryList();
  },
  provide() {
    return {
      refresh: this.getStationeryList,
    };
  },
  methods: {
    stationerySearch(e) {
      this.stationeryName = e;
      this.getStationeryList();
    },
    addStationeryShowChange(e) {
      this.addStationeryShow = e;
    },
    getStationeryList() {
      // this.getListResult = "loading";
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        itemName: this.stationeryName,
      };
      this.get(this.$url.selectSchoolStationeryList, data).then((res) => {
        // console.log("查询学校文具列表==>", res);
        this.total = res.total;
        if (this.total <= 0) return (this.getListResult = "nullData");
        this.getListResult = "success";
        this.stationeryList = res.rows;
      });
    },
    // 分页组件传递过来的页码修改事件
    currentPageNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getStationeryList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getStationeryList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./stationery.scss";
</style>